export default __webpack_public_path__ + "static/media/buhoromijoz.40b250c1.webp";